export default "__VITE_ASSET__0aeb79f6__"